<div class="m-2">
    <kendo-label *ngIf="isLabelVisible()" [for]="getControlName()" [text]="getLabel()">
        <span *ngIf="isRequired()" class="required">*</span>
    </kendo-label>
    <kendo-textarea *ngIf="isControlVisible()" [id]="getControlName()" [name]="getControlName()" [(ngModel)]="formValues[getName()]" [required]="isRequired()" [rows]="5">
    </kendo-textarea>
</div>